import { render, staticRenderFns } from "./SaveThePlanet.vue?vue&type=template&id=56641088&scoped=true&"
import script from "./SaveThePlanet.vue?vue&type=script&lang=js&"
export * from "./SaveThePlanet.vue?vue&type=script&lang=js&"
import style0 from "./SaveThePlanet.vue?vue&type=style&index=0&id=56641088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56641088",
  null
  
)

component.options.__file = "SaveThePlanet.vue"
export default component.exports